import { useEffect } from 'react';

const RenderPreviewModal = ({
  open = false,
  src = '',
  onClose,
  ariaLabel = 'Render preview',
  alt = 'Render preview full size',
  mediaType = 'image',
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open || !src?.trim()) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel}
      onClick={() => onClose?.()}
    >
      <div
        className="relative max-h-[92vh] max-w-[92vw] rounded-2xl border border-white/20 bg-white p-3 shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={() => onClose?.()}
          className="absolute right-3 top-3 z-10 flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-700 shadow-sm transition-colors hover:border-primary-300 hover:text-primary-300"
          title="Close preview"
          aria-label="Close preview"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <path d="M18 6L6 18" />
            <path d="M6 6l12 12" />
          </svg>
        </button>
        {mediaType === 'video' ? (
          <video
            src={src}
            className="max-h-[85vh] max-w-[88vw] object-contain"
            controls
            autoPlay
            playsInline
          />
        ) : (
          <img
            src={src}
            alt={alt}
            className="max-h-[85vh] max-w-[88vw] object-contain"
            draggable={false}
            referrerPolicy="no-referrer"
          />
        )}
      </div>
    </div>
  );
};

export default RenderPreviewModal;
